/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Mobile Menu Toggle Button.
 */

import React from "react";

export const MobileMenuToggleButton = ({ icon, handleClick }) => {
  return (
    <span
      className="MobileNavBar__toggle material-icons"
      id="MobileMenuToggleButton"
      onClick={handleClick}
    >
      {icon}
    </span>
  );
};
